(function () {
  'use strict';

  function CollectionSlider(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-slider-viewport]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-slider-slide]'));
    this.previous = root.querySelector('[data-slider-previous]');
    this.next = root.querySelector('[data-slider-next]');
    this.dots = root.querySelector('[data-slider-dots]');
    this.autoplay = Math.max(0, Number(root.dataset.autoplay) || 0) * 1000;
    this.loop = root.dataset.loop !== 'false';
    this.index = 0;
    this.timer = null;
  }

  CollectionSlider.prototype.visibleCount = function () {
    if (!this.viewport || !this.slides.length) return 1;
    var slideWidth = this.slides[0].getBoundingClientRect().width;
    return Math.max(1, Math.round(this.viewport.getBoundingClientRect().width / Math.max(slideWidth, 1)));
  };

  CollectionSlider.prototype.maxIndex = function () {
    return Math.max(0, this.slides.length - this.visibleCount());
  };

  CollectionSlider.prototype.init = function () {
    var self = this;
    if (!this.viewport || !this.slides.length) return;

    if (this.previous) this.previous.addEventListener('click', function () { self.go(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1); });
    this.viewport.addEventListener('scroll', function () { self.syncFromScroll(); }, { passive: true });
    this.root.addEventListener('mouseenter', function () { self.stop(); });
    this.root.addEventListener('mouseleave', function () { self.start(); });
    this.root.addEventListener('focusin', function () { self.stop(); });
    this.root.addEventListener('focusout', function () { self.start(); });
    window.addEventListener('resize', function () { self.renderControls(); });

    this.renderDots();
    this.renderControls();
    this.start();
  };

  CollectionSlider.prototype.go = function (index) {
    var max = this.maxIndex();
    if (index > max) index = this.loop ? 0 : max;
    if (index < 0) index = this.loop ? max : 0;
    this.index = index;

    var slide = this.slides[index];
    if (slide) {
      this.viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    this.renderControls();
  };

  CollectionSlider.prototype.syncFromScroll = function () {
    var self = this;
    var viewportLeft = this.viewport.scrollLeft;
    var nearest = 0;
    var distance = Infinity;
    this.slides.forEach(function (slide, index) {
      var nextDistance = Math.abs(slide.offsetLeft - viewportLeft);
      if (nextDistance < distance) {
        nearest = index;
        distance = nextDistance;
      }
    });
    self.index = Math.min(nearest, self.maxIndex());
    self.renderControls();
  };

  CollectionSlider.prototype.renderDots = function () {
    var self = this;
    if (!this.dots) return;
    this.dots.innerHTML = '';
    var total = this.maxIndex() + 1;
    for (var index = 0; index < total; index += 1) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'custom-collection-slider__dot';
      dot.setAttribute('aria-label', (index + 1) + '枚目を表示');
      dot.dataset.index = index;
      dot.addEventListener('click', function (event) { self.go(Number(event.currentTarget.dataset.index)); });
      this.dots.appendChild(dot);
    }
  };

  CollectionSlider.prototype.renderControls = function () {
    var max = this.maxIndex();
    var hide = max === 0;
    if (this.previous) {
      this.previous.hidden = hide;
      this.previous.disabled = !this.loop && this.index === 0;
    }
    if (this.next) {
      this.next.hidden = hide;
      this.next.disabled = !this.loop && this.index === max;
    }
    if (this.dots) {
      if (this.dots.children.length !== max + 1) this.renderDots();
      this.dots.hidden = hide || this.root.dataset.showDots === 'false';
      Array.prototype.forEach.call(this.dots.children, function (dot, index) {
        dot.classList.toggle('is-active', index === this.index);
        if (index === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      }, this);
    }
  };

  CollectionSlider.prototype.start = function () {
    var self = this;
    this.stop();
    if (!this.autoplay || this.maxIndex() === 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = window.setInterval(function () { self.go(self.index + 1); }, this.autoplay);
  };

  CollectionSlider.prototype.stop = function () {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  };

  function initialize(scope) {
    (scope || document).querySelectorAll('[data-collection-slider]').forEach(function (root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      new CollectionSlider(root).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
